module.exports = __webpack_public_path__ + "89943c103d9b8782107ebc2e9c97cca3.png";